import Swal from "sweetalert2";
import { postTransportEsc, putTransportEsc } from "../services/transport.services";
import { compressor } from "./compressorjs";

export const onSubmitHabilitacion = async (data, setLoading) => {
  const {
    DNIpdf,
    afip,
    iibb,
    libre_deuda,
    libre_multa,
    antecedentes,
    carnet,
    legalPerson,
    titulo,
    vtv,
    cedula,
    seguro_responsabilidad_civil,
    poliza,
    pago_seguro,
    carnet_chofer,
    dni_celador,
    antecedentes_celador,
    imgFront,
    imgSide,
    imgBack,
    imgIn,
    declaracion_jurada,
    // office
  } = data;

  if (
    (DNIpdf && !DNIpdf[0]) ||
    (afip && !afip[0]) ||
    (iibb && !iibb[0]) ||
    (libre_deuda && !libre_deuda[0]) ||
    (libre_multa && !libre_multa[0]) ||
    (antecedentes && !antecedentes[0]) ||
    (carnet && !carnet[0]) ||
    (titulo && !titulo[0]) ||
    (vtv && !vtv[0]) ||
    (cedula && !cedula[0]) ||
    (seguro_responsabilidad_civil && !seguro_responsabilidad_civil[0]) ||
    (poliza && !poliza[0]) ||
    (pago_seguro && !pago_seguro[0]) ||
    (carnet_chofer && !carnet_chofer[0]) ||
    (dni_celador && !dni_celador[0]) ||
    (antecedentes_celador && !antecedentes_celador[0]) ||
    (imgFront && !imgFront[0]) ||
    (imgSide && !imgSide[0]) ||
    (imgBack && !imgBack[0]) ||
    (imgIn && !imgIn[0]) ||
    (declaracion_jurada && !declaracion_jurada[0])
    // (office && !office[0])
  ) {
    return Swal.fire(
      "Error",
      "Debe enviar todos los documentos requeridos",
      "error"
    );
  }
  setLoading(true);
  let formData = new FormData();

  let front = await compressor(imgFront[0]);
  let side = await compressor(imgSide[0]);
  let back = await compressor(imgBack[0]);
  let inside = await compressor(imgIn[0]);

  if (legalPerson) {
    for (let i = 0; i < legalPerson.length; i++) {
      formData.append("legalPerson", legalPerson[i], legalPerson[i].name);
    }
  }

  formData.append("imgFront", front, front.name);
  formData.append("imgSide", side, side.name);
  formData.append("imgBack", back, back.name);
  formData.append("imgIn", inside, inside.name);
  formData.append("DNIpdf", DNIpdf[0], DNIpdf[0].name);
  formData.append("afip", afip[0], afip[0].name);
  formData.append("iibb", iibb[0], iibb[0].name);
  formData.append("libre_deuda", libre_deuda[0], libre_deuda[0].name);
  formData.append("libre_multa", libre_multa[0], libre_multa[0].name);
  formData.append("antecedentes", antecedentes[0], antecedentes[0].name);
  formData.append("carnet", carnet[0], carnet[0].name);
  formData.append("titulo", titulo[0], titulo[0].name);
  formData.append("vtv", vtv[0], vtv[0].name);
  formData.append("cedula", cedula[0], cedula[0].name);
  formData.append("seguro_responsabilidad_civil", seguro_responsabilidad_civil[0], seguro_responsabilidad_civil[0].name);
  formData.append("poliza", poliza[0], poliza[0].name);
  formData.append("pago_seguro", pago_seguro[0], pago_seguro[0].name);
  formData.append("carnet_chofer", carnet_chofer[0], carnet_chofer[0].name);
  formData.append("dni_celador", dni_celador[0], dni_celador[0].name);
  formData.append("antecedentes_celador", antecedentes_celador[0], antecedentes_celador[0].name);
  formData.append("declaracion_jurada", declaracion_jurada[0], declaracion_jurada[0].name);
  // formData.append("office", office[0], office[0].name);

  formData.append("values", JSON.stringify(data));

  const res = await postTransportEsc(formData);

  if (res.status === 201) {
    setLoading(false);
    Swal.fire({
      title: "Exito",
      text: "Trámite iniciado con éxito. Evaluaremos la documentación enviada y se le notificará vía correo electrónico",
      icon: "success",
      willClose: () => window.location.replace("/"),
    });
  } else {
    setLoading(false);
    Swal.fire({
      title: "Error",
      text: `${res.response?.data?.message || "Ocurrió un error al registrar el trámite. Intente nuevamente"}`,
      icon: "error",
      willClose: () => window.location.replace("/"),
    });
  }
  setLoading(false);
};

export const onSubmitRehabilitacion = async (data, setLoading) => {
  const {
    DNIpdf,
    carnet,
    legalPerson,
    titulo,
    vtv,
    cedula,
    seguro_responsabilidad_civil,
    poliza,
    pago_seguro,
    carnet_chofer,
    dni_celador,
    antecedentes_celador,
    imgFront,
    imgSide,
    imgBack,
    imgIn,
    declaracion_jurada,
    // office
  } = data;
  if (
    (DNIpdf && !DNIpdf[0]) ||
    (carnet && !carnet[0]) ||
    (titulo && !titulo[0]) ||
    (vtv && !vtv[0]) ||
    (cedula && !cedula[0]) ||
    (seguro_responsabilidad_civil && !seguro_responsabilidad_civil[0]) ||
    (poliza && !poliza[0]) ||
    (pago_seguro && !pago_seguro[0]) ||
    (carnet_chofer && !carnet_chofer[0]) ||
    (dni_celador && !dni_celador[0]) ||
    (antecedentes_celador && !antecedentes_celador[0]) ||
    (imgFront && !imgFront[0]) ||
    (imgSide && !imgSide[0]) ||
    (imgBack && !imgBack[0]) ||
    (imgIn && !imgIn[0]) ||
    (declaracion_jurada && !declaracion_jurada[0])
    // (office && !office[0])
  ) {
    return Swal.fire(
      "Error",
      "Debe enviar todos los documentos requeridos",
      "error"
    );
  }
  setLoading(true);
  let formData = new FormData();

  let front = await compressor(imgFront[0]);
  let side = await compressor(imgSide[0]);
  let back = await compressor(imgBack[0]);
  let inside = await compressor(imgIn[0]);

  if (legalPerson) {
    for (let i = 0; i < legalPerson.length; i++) {
      formData.append("legalPerson", legalPerson[i], legalPerson[i].name);
    }
  }

  formData.append("imgFront", front, front.name);
  formData.append("imgSide", side, side.name);
  formData.append("imgBack", back, back.name);
  formData.append("imgIn", inside, inside.name);
  formData.append("DNIpdf", DNIpdf[0], DNIpdf[0].name);
  formData.append("carnet", carnet[0], carnet[0].name);
  formData.append("titulo", titulo[0], titulo[0].name);
  formData.append("vtv", vtv[0], vtv[0].name);
  formData.append("cedula", cedula[0], cedula[0].name);
  formData.append("seguro_responsabilidad_civil", seguro_responsabilidad_civil[0], seguro_responsabilidad_civil[0].name);
  formData.append("poliza", poliza[0], poliza[0].name);
  formData.append("pago_seguro", pago_seguro[0], pago_seguro[0].name);
  formData.append("carnet_chofer", carnet_chofer[0], carnet_chofer[0].name);
  formData.append("dni_celador", dni_celador[0], dni_celador[0].name);
  formData.append("antecedentes_celador", antecedentes_celador[0], antecedentes_celador[0].name);
  formData.append("declaracion_jurada", declaracion_jurada[0], declaracion_jurada[0].name);
  // formData.append("office", office[0], office[0].name);

  formData.append("values", JSON.stringify(data));

  const res = await putTransportEsc(formData);

  if (res.status === 201) {
    setLoading(false);
    Swal.fire({
      title: "Exito",
      text: "Trámite iniciado con éxito. Evaluaremos la documentación enviada y se le notificará vía correo electrónico",
      icon: "success",
      willClose: () => window.location.replace("/"),
    });
  } else {
    setLoading(false);
    Swal.fire({
      title: "Error",
      text: `${res.response?.data?.message || "Ocurrió un error al registrar el trámite. Intente nuevamente"}`,
      icon: "error",
      willClose: () => window.location.replace("/"),
    });
  }
  setLoading(false);
};
